import PropTypes from 'prop-types';
import { useMemo } from 'react';

import { Box } from '@hivebrite/design-system/Box';
import { Divider } from '@hivebrite/design-system/Divider';
import { PillsList } from '@hivebrite/design-system/PillsList';

import { itemTypeLabel } from 'hb-react/frontoffice/apps/LiveFeed/utils/itemTypeLabel';
import CommentedLabel from 'hb-react/frontoffice/components/CommentedLabel';
import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { itemCommentedLabelParams } from 'hb-react/frontoffice/utils/itemCommentedLabel';

const LandingHeader = ({ itemType, item, showTypeHeader }) => {
  const { currentNetwork } = useDefaultAppContexts();
  const { pinned } = item;

  const commentedLabelParams = itemCommentedLabelParams({ item });

  const typeLabel = itemTypeLabel({
    itemType,
    pinned,
    pageCustomizables: currentNetwork.app_pages,
  });

  const ExternalComponent = useMemo(() => {
    // 1. Not pinned post is bumped by comment, explain which comment
    if (showTypeHeader && !pinned && commentedLabelParams) {
      return <CommentedLabel {...commentedLabelParams} />;
    }

    // 2. Has post type description
    if (showTypeHeader && typeLabel) {
      return <Box font="h4-semibold">{typeLabel}</Box>;
    }

    // 3. No label available
    return null;
  }, [typeLabel, commentedLabelParams, pinned]);

  // Tightly related to the logic of ExternalComponent.
  const shouldRenderPostLabel =
    showTypeHeader && !!(typeLabel || commentedLabelParams);
  const itemHasCategories = item?.categories?.length > 0;
  const renderDivider = shouldRenderPostLabel || itemHasCategories;
  const dividerMarginTop = itemHasCategories ? 1 : 4;

  return (
    <>
      <Box mt={{ _: 0 }}>
        {itemHasCategories ? (
          <PillsList
            pills={item.categories}
            ExternalComponent={ExternalComponent}
            seeMoreLabel={s__('Tags|See all')}
            seeLessLabel={s__('Tags|See less')}
          />
        ) : (
          ExternalComponent
        )}
      </Box>
      {renderDivider && (
        <Box height={dividerMarginTop * 4 + 1}>
          <Divider mt={dividerMarginTop} mb={0} />
        </Box>
      )}
    </>
  );
};

LandingHeader.propTypes = {
  itemType: PropTypes.string,
  item: PropTypes.object,
  showTypeHeader: PropTypes.bool,
};

export default LandingHeader;
